import React from "react"
import ErrorLoading from "./ErrorLoading"
import CourseCurriculum, { Loading } from "./CourseCurriculum"
import { useMembershipJourney } from "../../../hooks/useMembershipJourney"
import { useRefetch } from "../../../hooks/useRefetch"
import { MembershipJourneyProvider } from "../MembershipJourney/MembershipJourneyContext"
import { flags, useFeatureFlags } from "../../../lib/feature-flags"
import { resolveAcceptableProgressStanding } from "../../../utils/resolveAcceptableProgressStanding"
import { shouldUseTerminatedGptpCopy } from "../../../utils/shouldSuppressAdvancementCtas"
import { GPTP_MESSAGE_VARIANT } from "../MembershipJourney/utils/suspensionUtils"

export const CourseCurriculumWrapper = () => {
  const { person, loading, error, refetch } = useMembershipJourney()
  const { isFetching, reload } = useRefetch()
  const [isTerminatedNoticeEnabled = false] =
    useFeatureFlags([flags.FLAG_FEAT_TERMINATED_NOTICE]) ?? []

  if (loading || isFetching) {
    return <Loading />
  }

  if (error || !person) {
    return <ErrorLoading refetch={refetch} reload={reload} />
  }

  const progressStanding = resolveAcceptableProgressStanding({
    me: person,
    pgmProgress: person?.pgmProgress,
  })

  const contextValue = {
    pgaId: person?.pgaId || person?.id,
    pgmProgress: person?.pgmProgress,
    me: person,
    progressStanding,
    gptpMessageVariant: shouldUseTerminatedGptpCopy({
      isTerminatedNoticeEnabled,
      standing: progressStanding,
    })
      ? GPTP_MESSAGE_VARIANT.TERMINATED
      : GPTP_MESSAGE_VARIANT.SUSPENDED,
  }

  return (
    <MembershipJourneyProvider value={contextValue}>
      <CourseCurriculum />
    </MembershipJourneyProvider>
  )
}

export default CourseCurriculumWrapper
